import React from 'react';
import { Link } from 'react-router-dom';
import './courses.css';

const LongTerm = () => {
    const topics = [
        "Synthesis", "Timing paths", "Floorplan and Placement", "CTS",
        "Routing", "Cross Talk", "Physical Cells", "Timing Exceptions",
        "Lab Sessions", "Interview Preparation"
    ];

    return (
        <div className="course-detail-page">
            <section className="detail-hero" data-aos="fade-up">
                <Link to="/courses/physical-design" className="back-link">&larr; Back to Physical Design</Link>
                <h1>41 Days <span>SYN_PNR_STA</span> Course</h1>
                <p>A comprehensive journey from basics to advanced physical implementation.</p>
            </section>

            <section className="detail-content">
                <div className="detail-grid">
                    <div className="curriculum glass" data-aos="fade-right">
                        <h3>What you will learn</h3>
                        <ul>
                            {topics.map((topic, index) => (
                                <li key={index}><span className="bullet"></span> {topic}</li>
                            ))}
                        </ul>
                    </div>
                    <div className="sticky-info" data-aos="fade-left">
                        <div className="info-box glass">
                            <h4>Course Details</h4>
                            <div className="info-row">
                                <span>Duration:</span>
                                <span>41 Days</span>
                            </div>
                            <div className="info-row">
                                <span>Fee:</span>
                                <span>₹75,000 + GST</span>
                            </div>
                            <Link to="/contact" className="btn btn-gold full-width">Enroll Now</Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default LongTerm;